import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string(),
  email: Yup.string().email("Invalid email").required("Email is required"),
  mobileCountryCode: Yup.string().required("Country code is required"),
  mobile: Yup.string().required("Mobile number is required"),
  dob: Yup.date().nullable(),
  nationality: Yup.array().of(Yup.string()).min(1, "At least one nationality is required"),
  gender: Yup.string(),
  image: Yup.string(),
  passwordOption: Yup.string().required("Password option is required"),
  password: Yup.string().when("passwordOption", {
    is: (value: string) => value === "setOwn",
    then: (schema) => schema.required("Password is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  emailVerification: Yup.boolean(),
  mobileVerification: Yup.boolean(),
  passwordResetRequired: Yup.boolean(),
  theme: Yup.string(),
  language: Yup.string(),
});